module.exports = __webpack_public_path__ + "2bddaba3c0d166e7a84b3b941f45914f.png";